import { API } from 'Amplify';
import { union } from 'lodash';

export const CUSTOM = 'custom:';

export class InvalidTimeRangeError extends Error {
  constructor(message) {
    super(message);
    this.name = 'InvalidTimeRangeError';
  }
}

/**
 * @param {string} thingName
 * @param {string} table
 * @param {*} dimensions
 * @param {Array<number>} timeRange
 * @param {Array<string>} measures
 * @returns result requested
 */
export const fetchDeviceData = (thingName, table, dimensions, timeRange, measures) => {
  let aggregate;
  const [timeStart, timeEnd] = timeRange;
  const interval = timeEnd - timeStart; // secs
  const intervalInMinutes = interval / 60;
  const intervalInHours = intervalInMinutes / 60;
  const intervalInDays = intervalInHours / 24;
  const intervalInMonths = intervalInDays / 30;

  // Converting to minutes that ensure the number of poins is guaranteed
  /*if (interval > totalPoints * granularity) { // To be accurate, should divide by granularity
        preAgg = Math.ceil(interval * granularity / 60 / totalPoints);
        aggregate = `${preAgg}m`;
    }*/

  if (intervalInHours <= 24) {
    aggregate = '1m';
  } else if (intervalInDays > 1 && intervalInDays <= 2) {
    aggregate = '15m';
  } else if (intervalInDays > 2 && intervalInDays <= 7) {
    aggregate = '1h';
  } else if (intervalInDays > 7 && intervalInDays <= 30) {
    aggregate = '1d';
  } else if (intervalInMonths >= 1 && intervalInMonths <= 3) {
    aggregate = '1d';
  } else if (intervalInMonths > 3 && intervalInMonths <= 12) {
    aggregate = '1w';
  } else if (intervalInMonths > 12) {
    aggregate = '1mo';
  }

  // Throw error if time range is invalid
  if (interval <= 60) {
    return Promise.reject(new InvalidTimeRangeError('Invalid time range: at least 1 minute is required to be in view'));
  }

  const body = { timeStart, timeEnd, table, measures, db: 'sampleDB', aggregate: table === 'savings' ? undefined : aggregate, dimensions, optimal: true };
  return API.post('IO_API', `/devices/${thingName}/timestream`, { body }).then((res) => {
    if (Object.keys(body).length < 1) {
      return null;
    }
    return res;
  });
};

const comparableByTime = (a, b) => {
  if (a.time < b.time) {
    return -1;
  }
  if (a.time > b.time) {
    return 1;
  }
  return 0;
};

export const sortData = (requestedData) => {
  return Object.entries(requestedData || {}).reduce(
    (acc, [measureName, measureArray]) => {
      const timeOrdered = measureArray.sort(comparableByTime);
      acc[measureName] = timeOrdered;
      //acc.timestamps = union(acc.timestamps, timeOrdered.map(obj => `${obj.time.split(" ").join("T").slice(0, -6)}Z`));
      acc.timestamps = union(
        acc.timestamps,
        timeOrdered.map((obj) => obj.time),
      );
      return acc;
    },
    { timestamps: [] },
  );
};
